import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IAlertState } from "../types";

// Define a notification type
interface Notification {
  type: "error" | "success";
  message: string;
}

const initialState: IAlertState = {
  isShowError: false,
  errorMessage: "",
  isShowSuccess: false,
  successMessage: "",
  currentNotification: null,
};

export const alertSlice = createSlice({
  name: "uiReducer",
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<Notification>) => ({
      ...state,
      currentNotification: action.payload,
    }),
    hideNotification: (state) => ({
      ...state,
      currentNotification: null,
    }),
  },
});

export const { showNotification, hideNotification } = alertSlice.actions;
export default alertSlice.reducer;
